"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnFidoImplementation = void 0;
const onfido_sdk_ui_1 = require("onfido-sdk-ui");
const AuthenticationFactorType_1 = require("../authentication/AuthenticationFactorType");
const IdentifyCustomerResult_1 = require("./IdentifyCustomerResult");
class OnFidoImplementation {
    identifyCustomer(sdkToken, authenticationFactors) {
        const onFidoSteps = this.buildOnFidoSteps(authenticationFactors);
        return new Promise(resolve => {
            const onFidoSDK = (0, onfido_sdk_ui_1.init)({
                token: sdkToken,
                steps: onFidoSteps,
                containerId: "identify-customer-container",
                onComplete: _data => {
                    onFidoSDK.tearDown();
                    resolve(IdentifyCustomerResult_1.IdentifyCustomerResult.COMPLETED);
                },
                onError: () => {
                    onFidoSDK.tearDown();
                    resolve(IdentifyCustomerResult_1.IdentifyCustomerResult.ERROR);
                },
                onUserExit: () => {
                    onFidoSDK.tearDown();
                    resolve(IdentifyCustomerResult_1.IdentifyCustomerResult.USER_EXITED);
                },
            });
        });
    }
    buildOnFidoSteps(authenticationFactors) {
        const steps = ["welcome"];
        authenticationFactors.forEach(authenticationFactor => {
            if (authenticationFactor.type === AuthenticationFactorType_1.AuthenticationFactorType.ID_DOCUMENT) {
                steps.push("document");
            }
            if (authenticationFactor.type === AuthenticationFactorType_1.AuthenticationFactorType.BIOMETRICS_FACE_SCAN_PROOFING) {
                steps.push("face");
            }
            if (authenticationFactor.type === AuthenticationFactorType_1.AuthenticationFactorType.LIVENESS) {
                const step = {
                    type: "face",
                    options: {
                        requestedVariant: "video",
                    },
                };
                steps.push(step);
            }
        });
        steps.push("complete");
        return steps;
    }
}
exports.OnFidoImplementation = OnFidoImplementation;
//# sourceMappingURL=OnFidoImplementation.js.map